import React, { useMemo } from "react";
import { useLocation } from "react-router-dom";
import { usePageMetadata } from "./usePageMetadata";

export default function RouteSeoDefaults() {
  const location = useLocation();
  const metadata = useMemo(() => {
    if (location.pathname === "/") {
      return {
        title: "Club Evolver | Gestión y seguimiento de torneos deportivos",
        description:
          "Organiza torneos deportivos y sigue grupos, partidos, resultados y eliminatorias en directo desde móvil, web o pantalla.",
        canonicalPath: "/",
        robots: "index,follow",
      };
    }

    if (location.pathname === "/documentacion") {
      return {
        title: "Documentación | Club Evolver",
        description: "Guía de Club Evolver para organizar, operar y publicar torneos deportivos.",
        canonicalPath: "/documentacion",
        robots: "index,follow",
      };
    }

    const isPublicTournamentRoute =
      /^\/(tournamentactions\/[^/]+(?:\/juegos)?|viewgroups\/[^/]+|matches\/[^/]+|viewbracket\/[^/]+)$/.test(
        location.pathname
      );

    return {
      title: isPublicTournamentRoute
        ? "Torneo en directo | Club Evolver"
        : "Panel de torneo | Club Evolver",
      description: isPublicTournamentRoute
        ? "Consulta grupos, partidos, resultados y eliminatorias del torneo."
        : "Panel privado de gestión de torneos de Club Evolver.",
      canonicalPath: location.pathname,
      robots: isPublicTournamentRoute ? "index,follow" : "noindex,nofollow",
    };
  }, [location.pathname]);

  usePageMetadata(metadata);
  return null;
}
